<template>
  <main-title>Запросы</main-title>
  <horizontal-filter>
    <template #default>
      <filter-item hash="#new" text="Новые запросы" />
      <filter-item hash="#inwork" text="В работе" />
      <filter-item hash="#archive" text="Архив" />
    </template>
    <template #right>
      <label class="panel__total-items"> Всего: {{ totalItems }} </label>
      <switch-cards-table-view
        :type-view="typeView"
        @update:type-view="handleUpdateTypeView"
      />
    </template>
  </horizontal-filter>
  <request-filter @update-filter="updateFilter" />
  <infinite-grid-layout
    :get-items="api.request.index"
    :url-params="urlParams"
    :scroll-bottom="scrollBottom"
    :one-column="typeView === 'table'"
    entity="requests"
    @update-total-count="handleUpdateTotalCount"
  >
    <template #table-header v-if="typeView === 'table'">
      <request-table-header />
    </template>
    <template #table-item="slotProps">
      <template v-if="typeView === 'table'">
        <request-table-item
          :request="slotProps.item"
          @click="handleClick(slotProps.item)"
        />
      </template>
      <template v-else>
        <request-card
          :request="slotProps.item"
          @click="handleClick(slotProps.item)"
        />
      </template>
    </template>
  </infinite-grid-layout>
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue';
  import { useApi } from '@/api/use-api';
  import { useRoute, useRouter } from 'vue-router';
  import MainTitle from '@/components/titles/MainTitle.vue';
  import HorizontalFilter from '@/components/filter/horizontal/HorizontalFilter.vue';
  import FilterItem from '@/components/filter/components/FilterItem.vue';
  import InfiniteGridLayout from '@/components/infinite-grid/InfiniteGridLayout.vue';
  import SwitchCardsTableView from '@/components/switch-view/SwitchCardsTableView.vue';
  import RequestFilter from '@/components/requests/components/RequestFilter.vue';
  import RequestTableItem from '@/components/requests/components/RequestTableItem.vue';
  import RequestCard from '@/components/requests/components/RequestCard.vue';
  import RequestTableHeader from '@/components/requests/components/RequestTableHeader.vue';

  defineProps({
    scrollBottom: Number,
  });

  const api = useApi();
  const router = useRouter();
  const route = useRoute();
  const totalItems = ref(0);
  const urlParams = ref(null);
  const typeView = ref('table');

  onMounted(async () => {
    urlParams.value = new URLSearchParams({
      tab: route.hash.replace('#', ''),
      role: route.meta.role,
    });
    // Добавляем параметры из запроса (нужно для обработки нажатия кнопки назад)
    if (route.query.textSearch) {
      urlParams.value.set('textSearch', route.query.textSearch);
    }
  });

  watch(
    () => route.hash,
    async () => {
      updateFilter(new URLSearchParams([...urlParams.value]));
    }
  );

  const updateFilter = (filterParams) => {
    filterParams.set('tab', route.hash.replace('#', ''));
    urlParams.value = filterParams;
  };

  const handleUpdateTypeView = (value) => {
    typeView.value = value;
  };

  const handleUpdateTotalCount = (value) => {
    totalItems.value = value;
  };

  const handleClick = async (request) => {
    await router.push({ path: '/administrator/requests/' + request.id });
  };
</script>

<style lang="scss" scoped>
  .panel__total-items {
    align-self: center;
  }
</style>
